import React from 'react';
import { HeaderLevel } from '../../types/AgilityTypes';

interface CustomHeaderProps {
  text: string;
  headerStyle?: {
    level?: HeaderLevel;
    color?: string;
    alignment?: string;
    [key: string]: any;
  } | null;
  'data-testid'?: string;
}

const CustomHeader = ({
  text,
  headerStyle,
  'data-testid': dataTestId,
}: CustomHeaderProps) => {
  const level = headerStyle?.level ?? 2;
  const color = headerStyle?.color ?? 'text-white';
  const alignment = headerStyle?.alignment ?? 'text-center';

  const inlineStyle: React.CSSProperties = {};

  if (headerStyle) {
    for (const key in headerStyle) {
      if (!['level', 'color', 'alignment'].includes(key)) {
        try {
          (inlineStyle as any)[key] = headerStyle[key];
        } catch (err) {
          if (process.env.NODE_ENV === 'development') {
            console.warn(`Failed to assign style property "${key}":`, err);
          }
        }
      }
    }
  }

  // Determine color: if it's a Tailwind class (starts with 'text-'), use as class; if it's a hex or rgb(a), use as style
  let colorClass = '';
  let colorStyle: React.CSSProperties = {};
  if (color.startsWith('text-')) {
    colorClass = color;
  } else if (color) {
    colorStyle.color = color;
  } else {
    colorClass = 'text-white';
  }
  let alignmentClass = '';
  let alignmentStyle: React.CSSProperties = {};
  if (alignment.startsWith('text-')) {
    alignmentClass = alignment;
  } else if (alignment) {
    alignmentStyle.color = alignment;
  } else {
    alignmentClass = 'text-center';
  }

  const className =
    `${colorClass} ${alignmentClass} ${headerStyle?.className || ''}`.trim();
  const mergedStyle = { ...inlineStyle, ...colorStyle, ...alignmentStyle };

  switch (level) {
    case 1:
    case 'h1':
      return (
        <h1 className={className} style={mergedStyle} data-testid={dataTestId}>
          {text}
        </h1>
      );
    case 2:
    case 'h2':
      return (
        <h2 className={className} style={mergedStyle} data-testid={dataTestId}>
          {text}
        </h2>
      );
    case 3:
    case 'h3':
      return (
        <h3 className={className} style={mergedStyle} data-testid={dataTestId}>
          {text}
        </h3>
      );
    case 4:
    case 'h4':
      return (
        <h4 className={className} style={mergedStyle} data-testid={dataTestId}>
          {text}
        </h4>
      );
    case 5:
    case 'h5':
      return (
        <h5 className={className} style={mergedStyle} data-testid={dataTestId}>
          {text}
        </h5>
      );
    case 6:
    case 'h6':
      return (
        <h6 className={className} style={mergedStyle} data-testid={dataTestId}>
          {text}
        </h6>
      );
    default:
      return (
        <h2 className={className} style={mergedStyle} data-testid={dataTestId}>
          {text}
        </h2>
      );
  }
};

export default CustomHeader;
